import { render } from "./ProfileTeacherPrice.vue?vue&type=template&id=a71b940c&scoped=true"
import script from "./ProfileTeacherPrice.vue?vue&type=script&lang=js"
export * from "./ProfileTeacherPrice.vue?vue&type=script&lang=js"

import "./ProfileTeacherPrice.vue?vue&type=style&index=0&id=a71b940c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71b940c"]])

export default __exports__